import React, { Component } from "react";
import { connect } from "@common/components/base.component";
import Address from "@common/components/addressGlobal/components/address.global.component";
import decaSelector from "../../../store/deca.selectors";
import enderecoPrincipalSelector from "../store/enderecoPrincipal.selectors";
import enderecoPrincipalActions from "../store/enderecoPrincipal.actions";
import { Row, Col } from "react-bootstrap";
import autoBind from "react-autobind";
import Panel from "@common/externos/components/panel/panel.component";

class Container extends Component {
  constructor(props) {
    super(props);
    autoBind(this);
  }

  render() {
    let { enderecoPrincipalSelector, prefix } = this.props;
    const { enderecoPrincipal } = enderecoPrincipalSelector;
    const { somenteEnderecoSede } = this.props.decaSelector.deca;

    return (
      <Panel
        title={"Endereço da Atividade"}
        defaultExpanded={false}
        Tooltip={
          "Endereço do local de estabelecimento do prestador, onde serão realizadas as atividades econômicas. Utilizado para fins de fiscalização."
        }
      >
        <Row>
          <Col>
            <Address
              name="EnderecoPrincipal"
              state={enderecoPrincipal}
              prefix={prefix}
              allowExterior={false}
              onBlur={(values) =>
                this.props.enderecoPrincipalActions.setEnderecoPrincipal(values)
              }
              filterCepBySede={somenteEnderecoSede}
            />
          </Col>
        </Row>
      </Panel>
    );
  }
}

export default connect({
  selectors: {
    enderecoPrincipalSelector,
    decaSelector,
  },
  actions: {
    enderecoPrincipalActions,
  },
})(Container);
